import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Loadable.scss';

class Loadable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { loadingClasses, loading, className, count, alignRight, ...rest } = this.props;
    const alignRightClass = alignRight ? styles.right : '';
    if (loading) {
      let skeletonClasses = loadingClasses.map(c => styles[`skeleton-${c}`]);
      let loadingItem = <div className={classNames("hx-skeleton", styles.skeleton, skeletonClasses, className, alignRightClass)} {...rest}>&nbsp;</div>;

      if (count > 1) {
        let results = [];
        for(let i = 0; i < count; i++) {
          results.push(React.cloneElement(loadingItem, { key: `item-${i}`}));
        }

        return (
          <div className={classNames(styles.countWrapper, alignRightClass)}>
            {results}
          </div>
        );
      }

      return loadingItem;
    }
    else {
      return <div style={{display: 'inline'}}>{this.props.children}</div>;
    }
  }
}

Loadable.propTypes = {
  count: PropTypes.number,
  loading: PropTypes.bool,
  loadingClasses: PropTypes.array
};

Loadable.defaultProps = {
  count: 1,
  loading: false,
  loadingClasses: []
};

export default Loadable;
export const LoadableSizeOptions = {
  BLOCK: 'block',
  BUTTON: 'button',
  BUTTON_XS: 'button-xs',
  FILL_25: 'fill-25',
  FILL_50: 'fill-50',
  FILL_75: 'fill-75',
  FILL_100: 'fill-100',
  HEADING: 'heading',
  ICON: 'icon',
  INLINE: 'inline'
};
